var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 16,
    viewBox: "0 0 90 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.7061 8.45711C90.0967 8.06658 90.0967 7.43342 89.7061 7.04289L83.3422 0.678932C82.9516 0.288408 82.3185 0.288408 81.928 0.678932C81.5374 1.06946 81.5374 1.70262 81.928 2.09315L87.5848 7.75L81.928 13.4069C81.5374 13.7974 81.5374 14.4305 81.928 14.8211C82.3185 15.2116 82.9516 15.2116 83.3422 14.8211L89.7061 8.45711ZM-0.000976563 8.75H88.999V6.75H-0.000976562L-0.000976563 8.75Z",
    fill: "#A9A9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrowLeft.c2f60f9584605c9e1ab58d1dc797d1e5.svg";
export { ForwardRef as ReactComponent };